import { Http, Headers } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";
var LayoutPrintFormService = (function () {
    function LayoutPrintFormService(http, appService) {
        this.http = http;
        this.appService = appService;
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }
    LayoutPrintFormService.prototype.getLayoutPrint = function (id) {
        var url = this.apiUrl + 'api/cms/layout-print/get/' + id;
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        return this.http.get(url, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    LayoutPrintFormService.prototype.createLayoutPrint = function (data) {
        var url = this.apiUrl + 'api/cms/layout-print/create';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    LayoutPrintFormService.prototype.editLayoutPrint = function (data) {
        var url = this.apiUrl + 'api/cms/layout-print/edit';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.put(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return LayoutPrintFormService;
}());
export { LayoutPrintFormService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print-form/layout-print-form.service.ts.pre-build-optimizer.js